module.exports = __webpack_public_path__ + "media/images/app/homepage/occasions/date-night-09172f9077702d45553864f22f6e18bc.webp";